<script>
  export let question;
  export let answerMap;
  export let numQuestion;
  export let finished;

  let showWarning = false;

  let selectAnswer = value => {
    answerMap[numQuestion] = answerMap[numQuestion] === value ? -1 : value;
    answerMap = answerMap;
  };
</script>

<style>
  div.questionContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    margin-bottom: 30px;
  }

  div.question {
    display: flex;
    background-color: var(--covid-title-blue);
    color: white;
    padding: 10px;
    min-height: 60px;
    margin-bottom: 20px;
    border-radius: 10px;
    -webkit-box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.57);
    -moz-box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.57);
    box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.57);
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  div.question div.img {
    background-color: white;
    border-radius: 50%;
    width: 65px;
    height: 65px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
  }

  div.question div.img img {
    height: 70%;
    width: 70%;
  }

  div.questionText {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  div.answers {
    display: flex;
    justify-content: space-between;
  }

  div.answers div {
    width: 15%;
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    background-color: var(--covid-answer);
    min-height: 60px;
    border-radius: 10px;
    cursor: pointer;
    -webkit-box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.57);
    -moz-box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.57);
    box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.57);
    font-size: 14px;
  }

  div.selected {
    background-color: var(--covid-answer-selected) !important;
    color: white !important;
  }

  /* Mobile phones */

  @media only screen and (max-width: 768px) {
    div.question {
      flex-direction: column;
      margin-bottom: 0px;
    }

    div.question div.img {
      margin-right: 0px;
      margin-bottom: 5px;
    }

    div.answers {
      flex-direction: column;
    }

    div.answers div {
      width: 100%;
      margin-top: 15px;
    }
  }
</style>

<div class="questionContainer">
  <div class="question">
    <div class="img">
      <img src={question.img} alt="Question icon" />
    </div>
    <div class="questionText">{question.question}</div>
  </div>
  <div class="answers">
    <div
      class={answerMap[numQuestion] === 0 ? 'selected' : ''}
      on:click={!finished ? () => selectAnswer(0) : null}>
      {question.answer1}
    </div>
    <div
      class={answerMap[numQuestion] === 1 ? 'selected' : ''}
      on:click={!finished ? () => selectAnswer(1) : null}>
      {question.answer2}
    </div>
    <div
      class={answerMap[numQuestion] === 2 ? 'selected' : ''}
      on:click={!finished ? () => selectAnswer(2) : null}>
      {question.answer3}
    </div>
    <div
      class={answerMap[numQuestion] === 3 ? 'selected' : ''}
      on:click={!finished ? () => selectAnswer(3) : null}>
      {question.answer4}
    </div>
    <div
      class={answerMap[numQuestion] === 4 ? 'selected' : ''}
      on:click={!finished ? () => selectAnswer(4) : null}>
      {question.answer5}
    </div>
    <div
      class={answerMap[numQuestion] === 5 ? 'selected' : ''}
      on:click={!finished ? () => selectAnswer(5) : null}>
      {question.answer6}
    </div>
  </div>
</div>
